module.exports = __webpack_public_path__ + "static/img/img4.dc02df8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5/img4.png
// module id = jvrY
// module chunks = 0